module.exports = __webpack_public_path__ + "static/feature4-4afd92c3f7584b707c085b79b9074b3c.png";